<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs />
        <div class="table-agile-info">
          <!--资源迁移-->
          <div class="common-new-title mode2">
            <span>资源迁移</span>
          </div>
          <el-form ref="form" :inline="true" label-width="100px" :model="searchData">
            <el-form-item prop="id" label="客户编码">
              <el-input clearable v-model="searchData.id" />
            </el-form-item>
            <el-form-item label="咨询老师">
              <el-select v-model="searchData.training_teacher" clearable placeholder="请选择" filterable color="red">
                <el-option-group v-for="(group, k) in ds.training_teacher" :key="k" :label="k">
                  <el-option v-for="item in group" :key="`${item.country}_${item.userid}`" :label="item.truename"
                             :value="item.userid" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="客户状态">
              <jm-dict-select v-model="searchData.customer_status" filterable clearable type="dataset"
                              dict-type="training" name="trainingLevelType" />
            </el-form-item>
            <el-form-item label="创建类型">
              <jm-dict-select v-model="searchData.create_type" clearable class="jm-input135"
                              dict="dataset.training.createType" />
            </el-form-item>
            <el-form-item label="创建日期">
              <el-date-picker v-model="searchData.create_time" type="daterange" unlink-panels placeholder="选择日期"
                              value-format="yyyy-MM-dd" class="jm-input280" />
            </el-form-item>
            <el-form-item label="推广人">
              <el-select v-model="searchData.custom_promoter" filterable clearable multiple placeholder="请选择">
                <el-option-group v-for="(group, k) in ds.create_person" :key="k" :label="k">
                  <el-option v-for="item in group.filter(item => item.userid > 0)" :key="item.userid"
                             :label="item.username" :value="item.userid" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="创建人">
              <el-select v-model="searchData.creator" filterable clearable placeholder="请选择">
                <el-option-group v-for="(group, k) in ds.create_person" :key="k" :label="k">
                  <el-option v-for="item in group" :key="item.userid" :label="item.username" :value="item.userid" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="回访次数">
              <el-input v-model="searchData.visit_count1" class="jm-input90" />
              <em>至</em>
              <el-input v-model="searchData.visit_count2" class="jm-input90" />
            </el-form-item>
            <el-form-item label="是否有电话">
              <el-checkbox @change="checkboxTel('has_tel')" border v-model="searchData.has_tel">有</el-checkbox>
              <el-checkbox @change="checkboxTel('no_tel')" border v-model="searchData.no_tel">无</el-checkbox>
            </el-form-item>
            <el-form-item label="渠道">
              <jm-channel v-model="channel" :is-all="true" clearable filterable />
            </el-form-item>
            <el-form-item label="渠道号">
              <el-input v-model="searchData.custom_final_from" clearable placeholder="填写此项将忽略渠道" />
            </el-form-item>
            <el-form-item label>
              <el-button type="primary" @click="handelSearch">筛选</el-button>
              <el-button type="default" @click="handelReset">重置</el-button>
            </el-form-item>
          </el-form>
          <el-form :inline="true" label-width="100px"
                   style="background-color:#f5f5f5;padding-top:20px;margin-bottom:15px">
            <el-form-item label="迁移类型">
              <el-select v-model="postData.field" ref="field" placeholder="请选择" clearable filterable>
                <el-option key="training_teacher" label="咨询老师" value="training_teacher" />
                <el-option key="custom_promoter" label="推广人" value="custom_promoter" />
                <el-option key="creator" label="创建人" value="creator" />
              </el-select>
            </el-form-item>
            <el-form-item label="接受者">
              <!--咨询老师-->
              <el-select :disabled="!postData.field" v-if="postData.field === 'training_teacher'"
                         v-model="postData.receiver" placeholder="请选择" clearable filterable>
                <el-option-group v-for="(group, k) in ds.training_teacher" :key="k" :label="k">
                  <el-option v-for="item in group" :key="`${item.country}_${item.userid}`" :label="item.truename"
                             :value="item.userid" />
                </el-option-group>
              </el-select>
              <!--创建人/推广人-->
              <el-select :disabled="!postData.field" v-else v-model="postData.receiver" placeholder="请选择" filterable
                         clearable>
                <el-option-group v-for="(group, k) in ds.create_person" :key="k" :label="k">
                  <el-option v-for="item in group.filter(item => item.userid > 0)" :key="item.userid"
                             :label="item.username" :value="item.userid" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="新客户状态">
              <jm-dict-select v-model="postData.customerStatus" filterable clearable type="dataset" dict-type="training"
                              name="trainingLevelType" />
            </el-form-item>
            <el-form-item label="">
              <el-switch @change="changeAmountModel" v-model="postData.useAmount" inactive-text="手动选择"
                         active-text="自定数量" />
            </el-form-item>
            <el-form-item>
              <el-input v-if="postData.useAmount" type="number" v-model="postData.amount" class="jm-input135" />
            </el-form-item>
            <el-form-item>
              <el-button class="jm-input135" type="danger" @click="handelTransfer">转移</el-button>
            </el-form-item>
          </el-form>

          <jm-table-list ref="teachersTable" url="/training/customer/pagetable" :search-data="searchData"
                         :refresh.sync="refresh" @selection-change="changeSelection" row-key="id">
            <el-table-column v-if="!postData.useAmount" align="center" slot="firstColumn" width="55" type="selection" />
          </jm-table-list>
        </div>
      </div>
    </div>
    <el-dialog :title="transferTaskCompleted ? '资源迁移完成' : '资源迁移中...'" :visible.sync="taskProgressVisible" width="30%"
               center :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <el-progress ref="taskProgress" style="width: 100%;line-height: 40px;" :text-inside="true" :stroke-width="20"
                   :percentage="transferTaskPercent" />
      <p v-if="transferTaskCompleted" style="font-size:12px; color:#39f">资源迁移已完成！</p>
      <p v-else style="font-size:12px; color:#999">迁移进度未完成，请不要关闭当前页面！</p>
      <div slot="footer">
        <el-button @click="handelFinish" type="primary" size="small" :disabled="!transferTaskCompleted">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import '@/assets/css/index.css';
import jmTableList from '@/components/data/tableList';
import { jmChannel, jmDictSelect } from '@/components/tool';
import student from '@/pages/student/student';

const MAX_PAGES = 100; // 最大页数
const PAGE_LIMIT = 100; // 每页数据限制
const transferTask = { // 迁移任务
  total: 0, // 任务总数
  completed: 0, // 完成总数
  init(amount) {
    this.total = amount;
    this.completed = 0;
  },
  addCompleted(finish) {
    this.completed += finish;
  },
  getBalance() {
    return this.total - this.completed;
  },
  getPercent() {
    if (!this.total) { return 0; }
    return Math.ceil((this.completed / this.total) * 100);
  },
};

let defaultSearchData = {
  id: '',
  creator: '',
  custom_promoter: '',
  create_time: '',
  training_teacher: '',
  customer_status: '',
  channels: {
    custom_from: '',
    custom_from_sub: '',
    custom_from_thrid: '',
    custom_from_fourth: '',
    custom_from_fifth: ''
  },
  has_tel: false,
  no_tel: false,
  visit_count1: '',
  visit_count2: '',
};

export default {
  components: {
    jmTableList,
    jmChannel,
    jmDictSelect
  },
  mixins: [student],
  data() {
    return {
      refresh: false,
      postData: {
        field: '',
        receiver: '',
        amount: 1,
        customerStatus: '',
        useAmount: false,
        userIds: [],
      },
      channel: {},
      channel_id: '',
      searchData: {},
      transferTask,
      taskProgressVisible: false
    };
  },
  computed: {
    transferTaskPercent() {
      return this.transferTask.getPercent();
    },
    transferTaskCompleted() {
      return this.transferTask.total > 0 && this.transferTask.getBalance() === 0;
    },
    createPersonZZ() {
      if (this.ds.create_person && this.ds.create_person.ZZ) {
        return this.ds.create_person.ZZ.filter(item => item.userid < 0);
      }
      return [];
    },
  },
  methods: {
    initSearchData() {
      this.searchData = Object.assign({}, defaultSearchData);

      this.searchData.channels.custom_from = '';
      this.searchData.channels.custom_from_sub = '';
      this.searchData.channels.custom_from_thrid = '';
      this.searchData.channels.custom_from_fourth = '';
      this.searchData.channels.custom_from_fifth = '';
    },
    handelSearch() {
      if (!this.channel_id || this.channel_id === '') {
        this.searchData.channel = this.channel;
        this.refresh = true;
      } else {
        this.$http._post({
          url: '/training/channel/getChannelMap',
          data: {
            channel_id: this.channel_id
          }
        }).then(({ data }) => {
          this.searchData.channel = data.channels;
          this.channel = {};
          this.refresh = true;
        });
      }
    },
    handelReset() {
      this.channel_id = '';
      this.channel = {};
      this.searchData = {
        showIgnore: false
      };
    },
    async handelTransfer() {
      if (!this.postData.field) {
        this.$message.error('迁移类型不能为空');
        return false;
      }
      if (!this.postData.receiver) {
        this.$message.error('接受者不能为空');
        return false;
      }

      let amount = 0;
      if (this.postData.useAmount) {
        amount = parseInt(this.postData.amount, 10);
        if (!amount) {
          this.$message.error('请输入数量');
          return false;
        }

        const max = MAX_PAGES * PAGE_LIMIT;
        if (amount > max) {
          this.$message.error(`请输入小于${max}的数量`);
          return false;
        }
      } else {
        amount = this.postData.userIds.length;
        if (!amount) {
          this.$message.error('请选择要操作的项');
          return false;
        }
      }

      // 任务初始化
      this.transferTask.init(amount);
      try {
        await this.$confirm('确定要进行资源迁移', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 开启进度条
        this.taskProgressVisible = true;

        // 执行迁移操作
        await this.doTansferTask(0);
      } catch (e) {
        this.taskProgressVisible = false;
        // this.$message.warning('操作异常，取消资源迁移');
      }
    },
    async doTansferTask(taskId) {
      // 未完成任务量
      let balance = this.transferTask.getBalance();
      if (balance <= 0) {
        return false;
      }
      // 当前任务 ID
      const max = MAX_PAGES * PAGE_LIMIT;
      if (taskId > MAX_PAGES) {
        this.$message.error(`迁移数量不能多于${max}条`);
      }

      // 当前处理量
      let amount = balance < PAGE_LIMIT ? balance : PAGE_LIMIT;

      // 提交数据
      const postData = Object.assign(
        {},
        this.postData,
        { amount: amount, _taskId: taskId }
      );
      await this.$http._post({
        url: '/training/customer/doTransfer',
        data: {
          postData: postData,
          searchData: this.searchData,
        }
      });
      this.transferTask.addCompleted(amount);
      taskId++;
      await this.doTansferTask(taskId);
    },
    handelFinish() {
      // 迁移成功
      this.taskProgressVisible = false;
      // 重新刷新
      this.refresh = true;
    },
    changeSelection(selection) {
      this.postData.userIds = selection.map(o => o.id);
    },
    changeAmountModel(value) {
      if (!value) {
        this.$refs.teachersTable.clearSelection();
      }
    },
    checkboxTel(type) {
      if (type === 'has_tel' && this.searchData.has_tel) {
        this.searchData.no_tel = false;
      }
      if (type === 'no_tel' && this.searchData.no_tel) {
        this.searchData.has_tel = false;
      }
    }
  },
  created() {
    this.initSearchData();
    this.getDatasource();
  },
  watch: {
  }
};
</script>
<style scoped>
.basic-title em.normal {
    border-bottom: none;
    color: #ccc;
}
</style>
